if (wishlistJs) {
  collectionPageJS();
}
else {
  console.log("Collection page wishlist JS not triggered");
}

function collectionPageJS() {
  const wishlistCollectionJS = document.getElementById('wishlistcollectionscript');
  let parsedWishlistCollectionJS = JSON.parse(wishlistCollectionJS.textContent);
  const vtnIconXPosition = parsedWishlistCollectionJS.iconXPosition;
  const vtnIconYPosition = parsedWishlistCollectionJS.iconYPosition;
  const wishlistAddedMessage = parsedWishlistCollectionJS.wishlistAddedMessage;
  const vtnCustomHeartIcon = document.getElementById('hidden-empty-wishlisthtml').innerHTML;
  const vtnCustomHeartFilledIcon = document.getElementById('hidden-filled-wishlisthtml').innerHTML;

  let heartIcon = `<svg class="vt-collection-icon vt-icon-heart" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <path d="M340.8,98.4c50.7,0,91.9,41.3,91.9,92.3c0,26.2-10.9,49.8-28.3,66.6L256,407.1L105,254.6c-15.8-16.6-25.6-39.1-25.6-63.9  c0-51,41.1-92.3,91.9-92.3c38.2,0,70.9,23.4,84.8,56.8C269.8,121.9,302.6,98.4,340.8,98.4 M340.8,83C307,83,276,98.8,256,124.8  c-20-26-51-41.8-84.8-41.8C112.1,83,64,131.3,64,190.7c0,27.9,10.6,54.4,29.9,74.6L245.1,418l10.9,11l10.9-11l148.3-149.8  c21-20.3,32.8-47.9,32.8-77.5C448,131.3,399.9,83,340.8,83L340.8,83z"/>
      </svg>`;
  let heartFilledIcon = `<svg class="vt-collection-icon-filled vt-icon-heart" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <path d="M340.8,83C307,83,276,98.8,256,124.8c-20-26-51-41.8-84.8-41.8C112.1,83,64,131.3,64,190.7c0,27.9,10.6,54.4,29.9,74.6  L245.1,418l10.9,11l10.9-11l148.3-149.8c21-20.3,32.8-47.9,32.8-77.5C448,131.3,399.9,83,340.8,83L340.8,83z"/>
      </svg>`;

  //create wishlistElement
  function collectionWishlistButton(card, productHandle, productId, productVariant = "") {
    let wishlistCollectionButton = document.createElement('wishlist-collection-button');
    wishlistCollectionButton.setAttribute('class', 'valign-' + vtnIconXPosition + ' align-' + vtnIconYPosition);
    wishlistCollectionButton.setAttribute('data-product-id', productId);
    wishlistCollectionButton.innerHTML = `<div class="add-wishlist vt-collection product-${productId}" data-product="${productId}" data-product-url="${productHandle}" data-variant="${productVariant}">${vtnCustomHeartIcon !== '' ? vtnCustomHeartIcon : heartIcon}</div>
          <div class="remove-wishlist vt-collection product-${productId}" data-product="${productId}" data-product-url="${productHandle}" style="display:none;" data-variant="${productVariant}">${vtnCustomHeartFilledIcon !== '' ? vtnCustomHeartFilledIcon : heartFilledIcon}</div>`;
    return wishlistCollectionButton;
  }

  // Insert wishlistButton and update them as per local
  function collectionButtons(wishlistData) {
    let collectionCards;
    /* Custom targeted element */
    const wishlistCollectionTarget = document.querySelectorAll('.vt-wishlist-custom-plp');
    if (wishlistCollectionTarget.length > 0) {
      collectionCards = wishlistCollectionTarget;
    }
    else {
      collectionCards = document.querySelectorAll('.card > div:not(.card__inner) .card__heading > .full-unstyled-link[href*=\"\/products\/\"]');
    }
    collectionCards.forEach(function (card) {
      let cardHandle, cardId, wishlistButton, variantId;
      if (wishlistCollectionTarget.length > 0) {
        cardId = card.getAttribute("data-product-id");
        cardHandle = card.getAttribute('data-product-handle');
        variantId = card.getAttribute('data-variant-id');
        wishlistButton = collectionWishlistButton(card, cardHandle, cardId, variantId);
        let parentItem = card.parentNode;
        if (!parentItem.querySelector('wishlist-collection-button')) {
        card.appendChild(wishlistButton);
        }
      }
      else {
        cardHandle = card.href.split('/products/')[1].split('?')[0];
        if (card.hasAttribute('id')) {
          let lastIndex = card.getAttribute('id').lastIndexOf('-')
          cardId = card.getAttribute('id').slice(lastIndex + 1);
        }
        wishlistButton = collectionWishlistButton(card, cardHandle, cardId);
        let parentItem = card.parentNode;
        if (!parentItem.querySelector('wishlist-collection-button')) {
          wishlistInsertAfter(wishlistButton, card);
        }else{
   
          variantId = card.nextSibling.querySelector('.add-wishlist').getAttribute('data-variant');
          let localwishlistData = getLocalStorageData();
          if (localwishlistData !== null && JSON.parse(localwishlistData).length > 0) {
            let wishlistData = JSON.parse(localwishlistData);
            let eleStatus = false;
            wishlistData.some(element => {
              if (element.wpdi === cardId && element.wpdvi === variantId) {eleStatus = true}
              if(eleStatus){
                card.nextSibling.querySelector('.add-wishlist').style.display = 'none';
                card.nextSibling.querySelector('.remove-wishlist').style.display = 'flex';  
              }else{
                card.nextSibling.querySelector('.add-wishlist').style.display = 'flex';
                card.nextSibling.querySelector('.remove-wishlist').style.display = 'none';
              } 
            })
          }
        }
      }

      /* preset wishlist button */
      if(variantId){
        let localwishlistData = getLocalStorageData();
        if (localwishlistData !== null && JSON.parse(localwishlistData).length > 0) {
          wishlistData.some(element => {
            if (element.wpdi === cardId && element.wpdvi === variantId) {

              if (wishlistCollectionTarget.length > 0) {
                card.querySelector('.add-wishlist').style.display = 'none';
                card.querySelector('.remove-wishlist').style.display = 'flex';
              }
              else {
                card.nextSibling.querySelector('.add-wishlist').style.display = 'none';
                card.nextSibling.querySelector('.remove-wishlist').style.display = 'flex';
              }
            }
          })
        }
      }
    })
  }

  function collectionButtonsRecheck(){
    let localwishlistData = getLocalStorageData();
    let wishlistData = '';
    if (localwishlistData !== null) {
      wishlistData = JSON.parse(localwishlistData);
    }
    collectionButtons(wishlistData)
  }

  collectionButtonsRecheck();



  async function getVariantDetails(card, pdHandle) {
    let pdDatatt = await queryProductDetailsFunction(pdHandle, vtnEndpoint, vtnStorefrontAccessToken, vtnCache);
    let pdId = pdDatatt.productByHandle.id.split('/Product/')[1];
    let pdVariants = pdDatatt.productByHandle.variants.edges;
    let pdVariantId = pdDatatt.productByHandle.variants.edges[0].node.id.split('/ProductVariant/')[1];

    if (pdVariants.length > 1) {
      for (let i = 0; i < pdVariants.length; i++) {
        let variantId = pdVariants[i].node.id.split('/ProductVariant/')[1];
        let variantAvailable = pdVariants[i].node.availableForSale;
        if (variantAvailable) {
          pdVariantId = variantId;
          break
        }
      }
    }
    let addWishlistElement = card.parentNode.querySelector('.add-wishlist');
    let removeWishlistElement = card.parentNode.querySelector('.remove-wishlist');
    addWishlistElement.setAttribute('data-variant', pdVariantId);
    removeWishlistElement.setAttribute('data-variant', pdVariantId);


    let localwishlistData = getLocalStorageData();
    if (localwishlistData !== null && JSON.parse(localwishlistData).length > 0) {
      let wishlistData = JSON.parse(localwishlistData);
      let elementStatus = false;
    
      wishlistData.some(element => {
        if (element.wpdi === pdId && element.wpdvi === pdVariantId) {elementStatus = true}
        if(elementStatus){
            card.querySelector('.add-wishlist').style.display = 'none';
            card.querySelector('.remove-wishlist').style.display = 'flex';  
        }else{
          card.querySelector('.add-wishlist').style.display = 'flex';
          card.querySelector('.remove-wishlist').style.display = 'none';
        } 
      })
    }



  }

  async function queryProductDetailsFunction(product, vtnEndpoint, vtnStorefrontAccessToken, vtnCache) {
    const query = `query getProductDetails{
                  productByHandle(handle: "${product}") {
                      id
                      variants(first:100){
                          edges{
                              node{
                              id
                              title
                              availableForSale
                              quantityAvailable
                              }
                          }
                      }
                  }
              }`;

    try {
      const result = await fetch(vtnEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': vtnStorefrontAccessToken,
        },
        body: JSON.stringify({
          ...(query && { query }),
        }),
        vtnCache,
      });
      const body = await result.json();
      return body.data;
    } catch (e) {
      console.error(e);
      console.log(e.message);
    }
  }

  function showAddedToWishlistNotification() {
    let addedToWishlistCollectionHtml = document.createElement('div');
    addedToWishlistCollectionHtml.className = 'fixed-wishlist-collection-notification';
    addedToWishlistCollectionHtml.innerHTML = `<div class="fixed-wishlist-collection-notification-inner">${wishlistAddedMessage}</div>`;
    document.querySelector('body').appendChild(addedToWishlistCollectionHtml);

    if(wishlistAddedMessage.indexOf('[') > -1 ){
      let firstText = wishlistAddedMessage.split('[')[0];
      let middleText = wishlistAddedMessage.split('[')[1].split(']')[0];
      let lastText = wishlistAddedMessage.split(']')[1];
      let finalWishlistAddedMessage =  `${firstText}<a href="${wishlistPageUrl}">${middleText}</a>${lastText}`;
      document.querySelector('.fixed-wishlist-collection-notification-inner').innerHTML = finalWishlistAddedMessage;
    }
  }
  showAddedToWishlistNotification();

  document.addEventListener("eventVtAddToWishlist", function (event) {
    if (wishlistAddedMessage) {
      let targetFrom = event.detail.targetFrom;
      let targetParentProduct = event.detail.targetParentProduct;
      if ((!targetParentProduct) && targetFrom !== "product" && targetFrom !== "cart") {
        let notificationElement = document.querySelector(
          ".fixed-wishlist-collection-notification"
        );
        notificationElement.style.right = "0";

        let collectionTimeoutId = setTimeout(function () {
          notificationElement.style.right = '-100%';
        }, 5500);

        notificationElement.addEventListener("mouseover", function () {
          clearTimeout(collectionTimeoutId);
        });

        notificationElement.addEventListener("mouseout", function () {
          collectionTimeoutId = setTimeout(function () {
            notificationElement.style.right = '-100%';
          }, 500);
        });

      }
    }
  });

  function wishlistButtons() {
    const wishlistButtons = document.querySelectorAll('wishlist-collection-button');
    if (document.querySelectorAll('.vt-wishlist-custom-plp').length === 0) {
      wishlistButtons.forEach(function (button) {
        let cardHandle = button.querySelector('.add-wishlist').getAttribute('data-product-url');
        getVariantDetails(button, cardHandle);
      })
    }

    addToWishlist('.add-wishlist.vt-collection', 'collection');
    removeFromWishlist('collection');
    if (window.location.href.indexOf('/collections/') > -1) {
      listenHTMLchange();
    }
  }
  wishlistButtons()

  window.vtWishlistPlpInit = reInitCheck;
  function reInit() {
    collectionButtonsRecheck();
    wishlistButtons();

  }
  function checkItemCounts(){
    return document.querySelectorAll('.collection-container li.column').length === document.querySelectorAll('.collection-container wishlist-collection-button').length;
  }
  function reInitCheck() {
    if (checkItemCounts()) {
      setTimeout(() => {
        if (!checkItemCounts()) {
          reInitCheck();
        }
      }, 1000);
      return;
    }
    else {
      setTimeout(() => {
        reInit();
        reInitCheck();
      }, 500)
    }
  }
  // check for network api hit for change of sort, page, filter
  const constantMockCheck = window.fetch;
  window.fetch = function () {
    return new Promise((resolve, reject) => {
      constantMockCheck
        .apply(this, arguments)
        .then((response) => {
          if ((
            (response.url.indexOf("page=") > -1) ||
            (response.url.indexOf("sort_by=") > -1) ||
            (response.url.indexOf("filter.") > -1) ||
            (response.url.indexOf("/recommendations/products") > -1)
          )
            && response.type != "cors") {
            reInitCheck();
          }
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  //listen to collection page changes
  function listenHTMLchange() {
    /* Filter inputs */
    let facetFilterFormElement = document.querySelector('facet-filters-form form');
    if (document.querySelectorAll('.vt-wishlist-custom-plp').length > 0) {
      if (document.querySelector('.filter-form') !== null) {
        facetFilterFormElement = document.querySelector('.filter-form')
      } else if (document.querySelector('.yv-collection-filter') !== null) {
        facetFilterFormElement = document.querySelector('.yv-collection-filter')
      }
    }
    if(facetFilterFormElement){
      facetFilterFormElement.querySelectorAll('input').forEach((element) =>
        element.addEventListener('change', function (e) { 
          reInitCheck();
        })
      );
    }
    /* filter remove */
    let facetRemoveElements = document.querySelectorAll('facet-remove');
    if(facetRemoveElements){
      facetRemoveElements.forEach(function (facetRemoveElement) {
        facetRemoveElement.addEventListener('click', function (e) {
          reInitCheck();
        })
      })
    }

    /* SortBy changes */
    if(document.querySelector('[name="sort_by"]')){
      var rad = document.querySelectorAll('[name="sort_by"]');
      for (var i = 0; i < rad.length; i++) {
          rad[i].addEventListener('change', function() {
              reInitCheck();
          });
      }
    }
  }

  //check and update status on remove
  function collectionButtonOnRemove(prodId, variId){
    let vtWishlistBtns = document.querySelectorAll('wishlist-collection-button');
    vtWishlistBtns.forEach(function (wishlistBtn) {
      let vtCardId = wishlistBtn.getAttribute('data-product-id');
      let vtVariantId = wishlistBtn.querySelector('.add-wishlist').getAttribute('data-variant');
      
      if(vtCardId === prodId && vtVariantId === variId){
        wishlistBtn.querySelector('.add-wishlist').style.display = 'flex';
        wishlistBtn.querySelector('.remove-wishlist').style.display = 'none';
      }
    })

  }

  // recheck and update wishlist status on event
  document.addEventListener('eventVtAddToWishlist', function (event) {
    collectionButtonsRecheck();
  });
  document.addEventListener('vtWishlistRemovefromWishlist', function (event) {
    collectionButtonOnRemove(event.detail.wpdi, event.detail.wpdvi);
  });

  window.onQuickView = onQuickView;
  function onQuickView(parent, wQuickVariantSelector) {
    let variantValue = wQuickVariantSelector.value;
    if (wQuickVariantSelector.value !== '') {
     parent.querySelector('.add-wishlist').setAttribute("data-variant", variantValue);
     parent.querySelector('.remove-wishlist').setAttribute("data-variant", variantValue);
    } 

    wQuickVariantSelector.addEventListener('change', function (event) {
      if(window.vtVariantChange){
        window.vtVariantChange(wQuickVariantSelector);
      }
    });
  }
}